<template>
  <div v-if="ambition?.title">
    <SplitContainerAmbition :ambition="ambition">
      <template #head>
        <div class="page-offset pt-14">
          <div class="grid-side-content">
            <div class="heading-detail break-words">
              {{ ambition.title }}
            </div>
            <SofieText
              class="prose-invert max-w-max !text-white"
              :value="`<p>${ambition.short_text}</p>`"
            />
          </div>
        </div>
      </template>

      <template #split>
        <img
          v-if="ambition.active_image"
          class="image aspect-long my-2.5 lg:my-10 lg:h-96"
          :src="ambition.active_image?.url"
          :alt="ambition.title"
        >
      </template>
    </SplitContainerAmbition>

    <section
      v-if="ambition.content_title"
      class="container space-y-5 pb-5 lg:space-y-20 lg:pb-20"
    >
      <article class="grid-side-content">
        <header class="heading lg:mb-8">
          {{ ambition.content_title }}
        </header>
        <SofieText
          class="prose max-w-none lg:text-lg"
          :value="ambition.content_text"
        />
      </article>
    </section>
    <section
      v-if="ambition.children.length"
      class="bg-sand overflow-hidden py-5 lg:py-20"
    >
      <div class="container">
        <header class="heading capitalize-first">
          {{ $t('Everything about {ambition}', {
            ambition: ambition.title
          }) }}
        </header>
        <AmbitionMessages
          class="!overflow-visible"
          :ambition="ambition"
        />
      </div>
    </section>

    <section
      v-if="articles?.data?.length"
      class="container py-5 lg:py-20"
    >
      <header class="heading capitalize-first">
        {{ $t('News') }}
      </header>
      <NewsHighlight :articles="articles.data" />
      <Btn
        :to="localePath('news')"
        :label="$t('Go to more news')"
        :short-label="$t('More news')"
      />
    </section>
  </div>
</template>

<script setup lang="ts">
import {useAmbitionQuery, useArticlesQuery} from '~/graphql/graphql';

const route = useRoute();

const {result} = useAmbitionQuery({
  slug: route.params.ambition,
});
const ambition = computed(() => result.value?.ambition ?? []);

const {result: articlesResult} = useArticlesQuery({
  ambition_id: ambition.value.id,
  limit: 4,
});
const articles = computed(() => articlesResult.value?.articles ?? []);
</script>
